// Shared response handling for API calls.
//
// The API answers an expired or rejected token with 401 and an EMPTY body, so
// calling .json() on it throws "SyntaxError: Unexpected end of JSON input" and
// the real cause (the session ended) is lost. Route responses through readJson
// instead: it drops the dead token - which is what every caller's
// "you may want to remove the invalid token" comment always intended - and
// returns null so the caller can bail out.
//
// 400 is deliberately allowed through to .json(): several actions return
// BadRequest with a JSON body (for example { email: "No user with this
// email" }) that the callers inspect.
function droppedToken(response, label) {
  if (response.status === 401) {
    localStorage.removeItem('token');
    console.warn(label + ': not authenticated (401)');
    return true;
  }
  return false;
}

export function readJson(response, label) {
  if (droppedToken(response, label)) {
    return null;
  }

  if (!response.ok && response.status !== 400) {
    throw new Error(label + ' responded ' + response.status);
  }

  return response.json();
}

// For calls whose answer carries nothing the caller needs, where .json() would
// throw on a perfectly good response: a void action (SaveUnreadMessages)
// answers 200 with an empty body, and an ActionResult<T> that returns null
// (UpdateLastSeen when it finds no row) answers 204. Same 401 handling as
// readJson; resolves true on success and throws on any other failure, so the
// caller's .catch is what reports it. A 400 counts as a failure here because
// nothing is going to read its body.
export function readStatus(response, label) {
  if (droppedToken(response, label)) {
    return null;
  }

  if (!response.ok) {
    throw new Error(label + ' responded ' + response.status);
  }

  return true;
}

export default readJson;



// WEBPACK FOOTER //
// ./src/actions/apiResponse.js